import { ErrorHandler, inject, NgModule, provideAppInitializer } from '@angular/core';
import { BrowserModule, Title, } from '@angular/platform-browser';
import { AppRoutingModule, routes } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideRouter, TitleStrategy, withComponentInputBinding, withRouterConfig } from '@angular/router';
// import { CustomRouteReuseStrategy } from './core/utils/custom.route-reuse-strategy';
import { RestartComponent } from './components/restart/restart.component';
import { SharedModule } from './shared/shared.module';
import { DirectivesModule } from './core/directives/directives.module';
import { UtilsService } from './core/utils/utils.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { WebdisplayPageTitleStrategy } from './core/title-strategy/webdisplay-title-strategy';

import { registerLocaleData } from '@angular/common';
import { LangService } from './core/utils/lang.service';

import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeCa from '@angular/common/locales/ca';
import localeEn from '@angular/common/locales/en';
import localePt from '@angular/common/locales/pt';
import localeZh from '@angular/common/locales/zh';
import localeDe from '@angular/common/locales/de';

import { AuthInterceptor } from './core/interceptors/auth-interceptor';
import { OverlayModule } from '@angular/cdk/overlay';
import { DisplayWsService } from './core/services/websocket/display/display-ws.service';
import { CustomErrorHandler } from './core/error/custom-error-handler';
import { HttpErrorInterceptor } from './core/interceptors/http-error-interceptor';
import { OverlayComponent } from "@adas/ng-overlay";
import { ConfigService } from './core/utils/config.service';
import { ThemeService } from './core/utils/theme-service.service';
import {Icon} from "./components/icon/icon";

// import * as Sentry from '@sentry/angular';

registerLocaleData(localeEs);
registerLocaleData(localeFr);
registerLocaleData(localeCa);
registerLocaleData(localeEn);
registerLocaleData(localePt);
registerLocaleData(localeZh);
registerLocaleData(localeDe);

export function initConfigFactory(): Promise<void> {
    const configService = inject(ConfigService);
    return configService.loadConfig();
}

@NgModule({
    declarations: [
        AppComponent,
        RestartComponent
    ],
    bootstrap: [
        AppComponent,
    ],
    exports: [
        CommonModule
    ],
    imports: [
        BrowserModule,
        CommonModule,
        AppRoutingModule,
        SharedModule,
        DirectivesModule,
        OverlayModule,
        OverlayComponent,
        Icon
    ],
    providers: [
        // Your existing providers
        CustomErrorHandler,
        {
            provide: ErrorHandler,
            useClass: CustomErrorHandler,
        },
        UtilsService,
        DisplayWsService,
        // { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
        Title,
        WebdisplayPageTitleStrategy,
        {
            provide: TitleStrategy,
            useExisting: WebdisplayPageTitleStrategy,
        },
        LangService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true,
        },
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        provideAppInitializer(
            initConfigFactory
        ),
        provideRouter(routes, withComponentInputBinding(), withRouterConfig({
            paramsInheritanceStrategy: 'always' // Permite heredar parámetros de padres
        })),
        ThemeService,
        // provideZoneChangeDetection({
        //     eventCoalescing: true,   // Agrupa eventos del DOM (clicks, inputs)
        //     runCoalescing: true      // Agrupa micro-tareas (promesas, timers)
        // })
        // Sentry providers (added to your existing providers)
        // {
        //     provide: ErrorHandler,
        //     useValue: Sentry.createErrorHandler(), // Sentry error handler to catch global errors
        // },
        // {
        //     provide: Sentry.TraceService,
        //     deps: [Router], // Sentry TraceService for routing-based error tracking
        // },
        // provideAppInitializer(() => {
        //     return new Promise<void>((resolve) => {
        //         inject(Sentry.TraceService);
        //         resolve();
        //     });
        // }),
    ]
})
export class AppModule { }
